//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

//Carousel Script
if (document.querySelector(".glide__slides")) {
	var allSlides = document.querySelectorAll(".glide");
	var allSlidesArray = Array.prototype.slice.call(allSlides);
	allSlidesArray.forEach((slide) => {
		const glide = new Glide(slide, {
			type: "slider",
			perView: 3,
			perTouch: 1,
			focusAt: "center",
			autoplay: false,
			accessibility: true,
			startAt: 2,
			rewind: false,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			},
			peek: {
				before: 100,
				after: 50,
			},
			perSwipe: "|",
			breakpoints: {
				800: {
					perView: 1,
					startAt: 1,
					peek: 0,
				},
			},
		}).mount();
	});
}

//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters
	// const filterBtn = document.querySelectorAll('.filters button');
	// var allfilterBtn = Array.prototype.slice.call(filterBtn);
	//let allblocks = document.querySelectorAll('.item');
	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;
		// if(selectedValue !== 'all'){
		//   allblocks = document.querySelectorAll('.item.block');
		// }
		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});

// submit form on select change
// Get the form element
const agentForm = document.querySelector('.listingFilters form');
if(agentForm){
agentForm.querySelectorAll('select')
if(agentForm){
	for(agent of agentForm){
		agent.addEventListener('change', function() {
			// Submit the form when the select value changes
			agentForm.submit();
		});
	}
	
}

}
// Add an event listener for the select field

(function(){
// Get all elements with the class .ac_
let acElements = document.querySelectorAll('.accordion-container .ac_');

// Loop through each element
if(!acElements){
	return false;
}
acElements.forEach((acElement, index) => {
  // Add a click event listener to each .ac_ element
  acElement.addEventListener('click', function() {
    // Get the corresponding .accordion-container element
    let accordionContainer = document.querySelectorAll('.accordion-container .ac-q')[index];
    
    // Check if the accordionContainer exists
    if(accordionContainer) {
      // Create a new Event
      let event = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });
      
      // Dispatch the event
      accordionContainer.dispatchEvent(event);
    } else {
      console.error('No corresponding .accordion-container found for .ac_ element at index ' + index);
    }
  });
});
})()

$(document).ready(function() {
    $('.toggle-link').click(function(e) {
      e.preventDefault();
     // var content = $(this).closest('.jobsrow').find('.job-content-panel');
	 var container = $(this).closest('.jobsrow');
	 var content = container.find('.job-content-panel');
	 var allOtherContainers = $('.jobsrow').not(container);
	 var allOtherContents = allOtherContainers.find('.job-content-panel');
	 var allOtherLinks = allOtherContainers.find('.toggle-link');

	 // Hide all other content divs
	 allOtherContents.slideUp('slow');
	 allOtherLinks.text('View Details');
      if (content.is(':hidden')) {
        content.slideDown('slow');
        $(this).text('Close');
      } else {
        content.slideUp('slow');
        $(this).text('View Details');
      }
    });
  });